module.exports = __webpack_public_path__ + "24db1f44a78649fd94d64b7fb0ca9299.svg";